export default class numberValidator {
    constructor() {
    }

    validate(value) {
        return !!value.match(/^[0-9]+$/);
    }
}
